module.exports = __webpack_public_path__ + "static/img/gun.6dd88d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src.common/assets/misc/gun.svg
// module id = 260
// module chunks = 0